import { render, staticRenderFns } from "./LuXiaoBai.vue?vue&type=template&id=6da9650c&scoped=true&"
import script from "./LuXiaoBai.vue?vue&type=script&lang=js&"
export * from "./LuXiaoBai.vue?vue&type=script&lang=js&"
import style0 from "./LuXiaoBai.vue?vue&type=style&index=0&id=6da9650c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9650c",
  null
  
)

export default component.exports